import ChartTooltip from 'components/chartTooltip';
import { scaleLog, select, sum } from 'd3';
import { formatDistance } from 'date-fns';
import useReactTooltipsOnD3 from 'hooks/useReactTooltipsOnD3';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedChildBin, TimelineContext } from 'utilities/srs-timeline-library/timeline';

export const TimelineTooltips: React.FC<{units?:string}> = ({units}) => {
	const { xScale, dataHeight, margin, yScale, data, svgRef, dataWidth } = useContext(TimelineContext);

	const toolTipOptions = {
		placement: 'top',
		 modifiers: [
			{
				name: 'offset',
				options: {
					offset: [0, 3],
				},
			},
		], 
	} 
	
	const toolTipMaker = ({start, end, label, values}:FormattedChildBin) => {
		const dateFormatter = 'MM/DD/YYYY';
		if(units) {
			values = {...values}
			const count = values.Count
			delete values.Count
			values[units] = count
		}
		
		return <ChartTooltip
			title={label}
			dateFormatter={dateFormatter}
			content={{
				Start: start,
				End: end,
				Duration: formatDistance(start, end),
				...values,
			}}
		/>
		
	}

	const [itemSelector,setItemSelector] = useState<()=>
		d3.Selection<d3.BaseType,FormattedChildBin,d3.BaseType,unknown>>()
	useEffect(() => {
		setItemSelector(()=> ()=>{ // setItemSelector calls this function once so I needed to wrap in a second function
			return select(svgRef.current)
				.select('#timeline-tooltips')
				.selectAll('rect')
				.data(data)
				.join('rect')
				.style('stroke', 'transparent')
				.style('fill', 'transparent')
				.attr('x', (d) => xScale(d.start))
				.attr('y', (d) => yScale(sum(Object.values(d.values))) || 0)
				.attr('height', (d) => {
					const height = dataHeight - yScale(sum(Object.values(d.values)));
					return height && height > 0 ? height : 0;
				})
				// Shrink the width by logarithmically to give a reasonable bar width and gap
				.attr('width', (d) => {
					const width = xScale(d.end) - xScale(d.start);
					return width * scaleLog().domain([5 / .75, 100]).range([0.75, 0.99]).clamp(true)(width);
				})
				.attr('cy-test', 'timeline-data-rect')
		})
	},[svgRef, data, xScale, yScale, dataHeight])

	const toolTip = useReactTooltipsOnD3(
		itemSelector,
		toolTipMaker,
		toolTipOptions
	)

	return (
		<React.Fragment>
			{toolTip}
			<g id="timeline-tooltips" transform={`translate(${0}, ${margin.top})`} width={dataWidth} />
		</React.Fragment>
	);
};
